import { today } from '@squadcore/api/shared/time'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { homeScope } from '~/features/home/queries'
import { mySessionsQuery, selfAllowed } from '~/features/self/queries'
import { SessionsPage } from '~/features/self/SessionsPage'
import { termineRange, type TermineSearch } from '~/features/self/search'

export const Route = createFileRoute('/_app/ich/termine')({
  beforeLoad: async ({ context }) => {
    if (!(await selfAllowed(context.queryClient))) throw redirect({ to: '/' })
  },
  validateSearch: (s: Record<string, unknown>): TermineSearch =>
    typeof s.ab === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s.ab) ? { ab: s.ab } : {},
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const scope = await homeScope(context.queryClient)
    if (!scope) return
    const { from, to } = termineRange(deps.ab ?? today(scope.timezone))
    await context.queryClient.ensureQueryData(mySessionsQuery(scope.teamId, scope.season, from, to)).catch(() => undefined)
  },
  component: function Termine() {
    return <SessionsPage search={Route.useSearch()} />
  },
})
